import { useCallback } from 'react';
import { supabase } from '@/lib/supabase/client';
import { useUserStore } from '@/store/userStore';

export const useUsers = () => {
  const { users, isLoading, error, fetchUsers } = useUserStore();

  const refreshUsers = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('status', 'active')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error refreshing users:', err);
      throw err;
    }
  }, []);

  return {
    users,
    isLoading,
    error,
    refreshUsers,
    fetchUsers
  };
};